import { MultiManageTeamMembeshipEntry } from "../teams/MultiManageTeamMembershipEntry";

export class MultiManageTeamMembershipRequest {
    entries: MultiManageTeamMembeshipEntry[] = [];
}